import Button from "components/Button";
import { Grid } from "components/Grid/Grid";
import Loader from "components/Loader";
import Modal from "components/Modal";
import Text from "components/Text";
import TextInput from "components/TextInput";
import PageContent from "pages/PageContent";
import {
    ProfileContentWrapper,
    StraightLine,
    SubHeading,
} from "pages/PageContent/PageContent.styled";
import { FC } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import theme from "theme";
import { OtherInterestGrid, TextAreaWrapper } from "./OtherInterests.styled";
import { useOtherInterests } from "./useOtherInterests";

export const OtherInterests: FC = () => {
    const {
        inputs,
        handleInputChange,
        inputErrors,
        isFetching,
        isLoading,
        onSubmit,
        handleSaveAndNext,
        hasClickedOnNext,
        handleBack,
        isModalOpen,
        toggleModal,
    } = useOtherInterests();

    return (
        <PageContent>
            <ProfileContentWrapper>
                <Text
                    variant="heading5"
                    fontWeight="700"
                    color={theme.colors.grey.dark}
                >
                    Complete Your Profile (5/7)
                </Text>
                <SubHeading variant="label">
                    OTHER INTERESTS <StraightLine />
                </SubHeading>
                {isFetching && <Loader size={28} />}
                <OtherInterestGrid>
                    <TextInput
                        placeholder="Eg. singing, guitar"
                        label="Enter values(Separated by comma)"
                        value={inputs.interests}
                        errorMsg={inputErrors.interests}
                        name="interests"
                        onChange={handleInputChange}
                    />
                </OtherInterestGrid>
                <SubHeading variant="label">
                    TELL US ABOUT YOURSELF <StraightLine />
                </SubHeading>
                <TextAreaWrapper>
                    <TextInput
                        name="my_story"
                        type="text"
                        label="My story(max 1000 characters)"
                        placeholder="Enter your story here"
                        multiLine
                        required
                        value={inputs.my_story}
                        errorMsg={inputErrors.my_story}
                        onChange={handleInputChange}
                    />
                </TextAreaWrapper>
                <Grid
                    row={true}
                    columnGap={1}
                    marginTop={3}
                    marginBottom={1}
                    rowGap={1}
                >
                    <Button
                        variant="outlined"
                        icon={<BsArrowLeft />}
                        iconPosition="prefix"
                        onClick={toggleModal}
                    >
                        Back
                    </Button>
                    <Button
                        variant="outlined"
                        isLoading={!hasClickedOnNext && isLoading}
                        onClick={onSubmit}
                    >
                        Save
                    </Button>
                    <Button
                        onClick={handleSaveAndNext}
                        disabled={isLoading}
                        isLoading={hasClickedOnNext && isLoading}
                        icon={<BsArrowRight />}
                    >
                        Save & Next
                    </Button>
                </Grid>
            </ProfileContentWrapper>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>
                    <Text variant="heading3">Confirm</Text>
                </Modal.Header>
                <Modal.Content>
                    <Text variant="body1">
                        Are you sure you want to leave? Any unsaved changes will
                        be lost.
                    </Text>
                </Modal.Content>
                <Modal.Footer>
                    <Grid
                        row={true}
                        justify="flex-end"
                        expanded
                        columnGap={1}
                        marginTop={2}
                        rowGap={1}
                    >
                        <Button
                            type="button"
                            variant="outlined"
                            onClick={toggleModal}
                        >
                            No
                        </Button>
                        <Button
                            type="button"
                            variant="filled"
                            onClick={handleBack}
                        >
                            Yes
                        </Button>
                    </Grid>
                </Modal.Footer>
            </Modal>
        </PageContent>
    );
};
